import type React from 'react';

import type { UseImageGalleryReturn } from './hooks/useImageGallery';
import type { GalleryItem, PaginationConfig } from './ImageGallery.common';

export type LightboxPagerProps = {
  images: GalleryItem[];
  lightboxIndex: number;
  setLightboxIndex: React.Dispatch<React.SetStateAction<number>>;
  pagination?: PaginationConfig;
  /**
   * Derived once by `Lightbox` and passed down so the size lookup — a network
   * round trip on native — is not run twice.
   */
  gallery: UseImageGalleryReturn;
  dimmedImageIds?: Set<number>;
};

export const isDimmedImage = (
  image: GalleryItem | undefined,
  dimmedImageIds: Set<number> | undefined
): boolean => image?.id != null && !!dimmedImageIds?.has(image.id);
